const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Urbe Talk",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida",
          alwaysAskQueue: "Sempre perguntar fila"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
        openChat: "Abrir o chat",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        notificationPopOverTitle: "Últimos Tickets",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Tickets",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          kanban: "Kanban",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        notificationPopOverTitle: "Últimos Tickets",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
          edit: "Editar",
          delete: "Excluir",
          kanban: "Configurar Kanban"
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      ticketCard: {
        defaultTitle: "Cartão de atendimento",
        created: "Cartão Kanban criado com sucesso",
        updated: "Cartão Kanban atualizado com sucesso",
        moved: "Cartão movido para outro estágio com sucesso",
        messageAdded: "Mensagem adicionada ao contexto do cartão",
        messageRemoved: "Mensagem removida do contexto do cartão",
        messagesAddedToContext: "Mensagens adicionadas ao contexto do cartão",
        noInitialStage: "Nenhum estágio inicial configurado para esta fila",
        noCardError: "Nenhum cartão Kanban associado a este ticket",
        selectionModeActive: "{{count}} mensagens selecionadas",
        finalized: "Ticket finalizado e cartão Kanban atualizado com sucesso",
        finalizeTicket: {
          title: "Finalizar Atendimento",
          subtitle: "Finalize o atendimento e atualize o cartão Kanban",
          cardInfo: "Informações do Cartão Kanban",
          moveToFinalStage: "O cartão será movido para o estágio: {{stage}}",
          includeMessages: "Incluir mensagens no contexto",
          doNotIncludeMessages: "Não incluir mensagens no contexto",
          selectedMessages: "{{count}} mensagens serão adicionadas ao contexto",
          moreMessages: "E mais {{count}} mensagens...",
          you: "Você",
          contact: "Contato",
          confirm: "Finalizar Atendimento",
          cancel: "Cancelar"
        },
        panel: {
          title: "Cartões",
          stage: "Estágio",
          priority: "Prioridade",
          priorityOptions: {
            low: "Baixa",
            medium: "Média",
            high: "Alta"
          },
          tags: "Tags",
          dueDate: "Data de vencimento",
          addToContext: "Adicionar ao contexto",
          removeFromContext: "Remover do contexto",
          emptyCard: "Nenhum cartão associado a este ticket",
          createCard: "Criar cartão",
          edit: "Editar cartão",
          save: "Salvar alterações",
          description: "Descrição",
          moveToStage: "Mover para {{stage}}",
          selectMessages: "Selecionar mensagens para contexto",
          cancelSelection: "Cancelar seleção",
          addSelectedToContext: "Adicionar {{count}} mensagens ao contexto",
          toggleKanban: "Mostrar/Ocultar Painel Kanban",
          cardFromDifferentQueue: "Atenção: Este cartão pertence a uma fila diferente da atual",
          changeQueue: "Mudar para outra fila",
          changeQueueMode: "Modo de mudança de fila",
          selectQueue: "Selecione a fila de destino",
          selectStage: "Selecione o estágio",
          queueChanged: "Cartão movido para outra fila com sucesso",
          cancelChangeQueue: "Cancelar mudança de fila",
          moveToQueueButton: "Mover para esta fila",
          moveToQueue: "Mudar para outra fila",
          noDescription: "Cartão não possui descrição",
          hideKanban: "Ocultar Painel Kanban",
          btnKanban: "Kanban",
          viewInKanban: "Ver no Kanban"
        },
        errors: {
          noQueue: "Ticket sem fila atribuida. É necessário atribuir uma fila antes de vincular um cartão"
        }
      },
      kanban: {
        title: "Quadro Kanban",
        loading: "Carregando...",
        disabled: "O Kanban está desativado para esta fila",
        enableButton: "Ativar Kanban",
        newStage: "Novo Estágio",
        selectQueue: "Selecionar Fila",
        notifications: {
          loadError: "Erro ao carregar dados do Kanban",
          settingsLoadError: "Erro ao carregar configurações do Kanban",
          stagesLoadError: "Erro ao carregar estágios do Kanban",
          cardsLoadError: "Erro ao carregar cartões do Kanban",
          enabled: "Kanban ativado com sucesso",
          disabled: "Kanban desativado com sucesso",
          autoCreateEnabled: "Criação automática de cartões ativada",
          autoCreateDisabled: "Criação automática de cartões desativada",
          saveError: "Erro ao salvar configurações",
          stageCreated: "Estágio criado com sucesso",
          stageUpdated: "Estágio atualizado com sucesso",
          stageDeleted: "Estágio excluído com sucesso",
          stageDeleteError: "Erro ao excluir estágio",
          stageSaveError: "Erro ao salvar estágio",
          stageMoveError: "Erro ao mover estágio",
          cardMoved: "Cartão movido com sucesso",
          cardMoveError: "Erro ao mover cartão",
          cardDeleted: "Cartão excluído com sucesso",
          cardDeleteError: "Erro ao excluir cartão"
        },
        settingsDialog: {
          title: "Configurações do Kanban",
          general: "Configurações Gerais",
          enableKanban: "Ativar Kanban para esta fila",
          autoCreateCards: "Criar cartões automaticamente para novos tickets",
          stages: "Estágios do Kanban",
          addStage: "Adicionar Estágio",
          noStages: "Nenhum estágio configurado. Adicione pelo menos um estágio para começar.",
          initialStage: "Inicial",
          finalStage: "Final",
          editStage: "Editar Estágio",
          newStage: "Novo Estágio",
          stageName: "Nome do Estágio",
          stageColor: "Cor do Estágio",
          isInitialStage: "É o estágio inicial",
          isFinalStage: "É o estágio final"
        },
        actions: {
          addCard: "Adicionar Cartão",
          editCard: "Editar",
          deleteCard: "Excluir",
          addStage: "Adicionar Estágio",
          editStage: "Editar",
          deleteStage: "Excluir"
        },
        dialogs: {
          deleteCard: {
            title: "Excluir Cartão",
            message: "Tem certeza que deseja excluir este cartão? Esta ação não pode ser desfeita."
          },
          deleteStage: {
            title: "Excluir Estágio",
            message: "Tem certeza que deseja excluir este estágio? Todos os cartões neste estágio serão perdidos. Esta ação não pode ser desfeita."
          }
        },
        buttons: {
          cancel: "Cancelar",
          save: "Salvar",
          close: "Fechar"
        },
        priorities: {
          low: "Baixa",
          medium: "Média",
          high: "Alta"
        },
        colors: {
          purple: "Roxo",
          blue: "Azul",
          green: "Verde",
          orange: "Laranja",
          red: "Vermelho",
          gray: "Cinza"
        },
        filters: {
          searchPlaceholder: "Buscar por título, descrição ou contato",
          priority: "Prioridade",
          responsible: "Responsável",
          tags: "Tags",
          all: "Todos",
          clearFilters: "Limpar Filtros"
        },
        noResponsible: "Sem responsável",
        fields: {
          title: "Título",
          description: "Descrição",
          priority: "Prioridade",
          assignedUser: "Atribuído a",
          dueDate: "Data de vencimento",
          stage: "Estágio",
          tags: "Tags",
          queue: "Fila",
          createdAt: "Criado em",
          updatedAt: "Atualizado em",
          messages: "Mensagens do contexto"
        },
        helperTexts: {
          separeteCommas: "Separe as tags com vírgulas",
          selectQueue: "Selecione a fila para este cartão",
        },
        settings: {
          title: "Configurações do Kanban",
          general: "Configurações Gerais",
          enableKanban: "Ativar Kanban para esta fila",
          autoCreateCards: "Criar cartões automaticamente para novos tickets",
          stages: "Etapas do Kanban",
          addStage: "Adicionar Etapa",
          noStages: "Nenhuma etapa configurada. Adicione pelo menos uma etapa para começar.",
          initialStage: "Etapa Inicial",
          finalStage: "Etapa Final",
          editStage: "Editar Etapa",
          newStage: "Nova Etapa",
          stageName: "Nome da Etapa",
          stageColor: "Cor da Etapa",
          isInitialStage: "É a etapa inicial",
          isFinalStage: "É a etapa final"
        },
        
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_REQUIRED: "Este campo é obrigatório.",
      },
    },
  },
};

export { messages };
